<div class="methodology-container">
  <h2 class="component-title">
    <mat-icon>science</mat-icon>
    {{ title }}
  </h2>

  <!-- Overall Methodology Scores -->
  @if(overallScores.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>dashboard</mat-icon>
      Methodology Overview
    </h3>
    <app-score-cards [universities]="overallScores" [metrics]="['Methodology Score']" [title]="'Methodology Scores (Your scores compared to others)'">
    </app-score-cards>
  </div>
  }

  <!-- Methodology Radar Chart -->
  <!-- @if(methodologyRadarData.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>radar</mat-icon>
      Methodology Components Analysis
    </h3>
    <app-polar-chart [polarChartData]="methodologyRadarData">
    </app-polar-chart>
  </div>
  } -->

  <!-- Methodology Bar Chart -->
  @if(methodologyBarData.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>bar_chart</mat-icon>
      Methodology Comparison
    </h3>
    <app-bar-chart [groupedBarData]="methodologyBarData">
    </app-bar-chart>
  </div>
  }

  <!-- Methodology Components Table -->
  @if(hasMethodologyComponents()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>table_chart</mat-icon>
      Detailed Methodology Components
    </h3>
    <app-table [dataSource]="methodologyTableData" [columns]="methodologyTableColumns"
      [displayedColumns]="getMethodologyTableColumns()">
    </app-table>
  </div>
  }

  <!-- Methodology Distribution -->
  <!-- @if(methodologyPieData.length > 0){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>pie_chart</mat-icon>
      Methodology Distribution
    </h3>
    <app-pie-grid [modelWiseScores]="methodologyPieData">
    </app-pie-grid>
  </div>
  } -->

  <!-- Overall Methodology Summary -->
  <!-- @if(hasOverallMethodology()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>assessment</mat-icon>
      Overall Methodology Summary
    </h3>
    <div class="summary-content">
      @if(overallMethodology.title){
      <h4>{{ overallMethodology.title }}</h4>
      }
      @if(overallMethodology.description){
      <p class="summary-text">{{ overallMethodology.description }}</p>
      }
      @if(overallMethodology.total_weight || overallMethodology.confidence_level ||
      overallMethodology.methodology_version){
      <div class="key-metrics">
        <h4>Key Metrics</h4>
        <div class="metrics-grid">
          @if(overallMethodology.total_weight){
          <div class="metric-card">
            <div class="metric-name">Total Weight</div>
            <div class="metric-value">{{ overallMethodology.total_weight }}%</div>
            <div class="metric-description">Total methodology weight distribution</div>
          </div>
          }
          @if(overallMethodology.confidence_level){
          <div class="metric-card">
            <div class="metric-name">Confidence Level</div>
            <div class="metric-value">{{ overallMethodology.confidence_level }}</div>
            <div class="metric-description">Overall confidence in methodology</div>
          </div>
          }
          @if(overallMethodology.methodology_version){
          <div class="metric-card">
            <div class="metric-name">Version</div>
            <div class="metric-value">{{ overallMethodology.methodology_version }}</div>
            <div class="metric-description">Current methodology version</div>
          </div>
          }
          @if(overallMethodology.last_updated){
          <div class="metric-card">
            <div class="metric-name">Last Updated</div>
            <div class="metric-value">{{ overallMethodology.last_updated }}</div>
            <div class="metric-description">Last methodology update</div>
          </div>
          }
        </div>
      </div>
      }
    </div>
  </div>
  } -->

  <!-- Data Quality Metrics -->
  <!-- @if(hasDataQualityMetrics()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>verified</mat-icon>
      Data Quality Metrics
    </h3>
    <div class="quality-content">
      @if(dataQualityMetrics.data_freshness || dataQualityMetrics.source_diversity ||
      dataQualityMetrics.verification_process){
      <div class="quality-metrics">
        <h4>Quality Indicators</h4>
        <ul class="metrics-list">
          @if(dataQualityMetrics.data_freshness){
          <li><strong>Data Freshness:</strong> {{ dataQualityMetrics.data_freshness }}</li>
          }
          @if(dataQualityMetrics.source_diversity){
          <li><strong>Source Diversity:</strong> {{ dataQualityMetrics.source_diversity }}</li>
          }
          @if(dataQualityMetrics.verification_process){
          <li><strong>Verification Process:</strong> {{ dataQualityMetrics.verification_process }}</li>
          }
          @if(dataQualityMetrics.transparency_score){
          <li><strong>Transparency Score:</strong> {{ dataQualityMetrics.transparency_score }}%</li>
          }
          @if(dataQualityMetrics.methodology_transparency){
          <li><strong>Methodology Transparency:</strong> {{ dataQualityMetrics.methodology_transparency }}
          </li>
          }
        </ul>
      </div>
      }
    </div>
  </div>
  } -->

  <!-- Evidence Sources -->
  @if(hasEvidenceSources()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>source</mat-icon>
      Methodology Data Sources
    </h3>
    <div class="evidence-grid">
      @for(evidence of evidenceSources; track evidence.url){
      <mat-card class="evidence-card">
        <mat-card-header>
          <mat-card-title>{{ evidence.source }}</mat-card-title>
          <mat-card-subtitle>
            <span class="evidence-category">{{ evidence.category }}</span>
            <span class="evidence-confidence">{{ (evidence.confidence * 100).toFixed(0) }}%
              confidence</span>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p>{{ evidence.snippet }}</p>
        </mat-card-content>
        <mat-card-actions>
          <a [href]="evidence.url" target="_blank" mat-button color="primary">
            <mat-icon>open_in_new</mat-icon>
            View Source
          </a>
        </mat-card-actions>
      </mat-card>
      }
    </div>
  </div>
  }

  <!-- Recommendations -->
  <!-- @if(hasRecommendations()){
  <div class="section">
    <h3 class="section-title">
      <mat-icon>lightbulb</mat-icon>
      Methodology Improvement Recommendations
    </h3>
    <div class="recommendations-grid">
      @for(rec of recommendations; track rec.category){
      <mat-card class="recommendation-card" [class]="'priority-' + rec.priority.toLowerCase()">
        <mat-card-header>
          <mat-card-title>{{ rec.issue }}</mat-card-title>
          <mat-card-subtitle>
            <span class="recommendation-category">{{ rec.category }}</span>
            <span class="recommendation-priority" [class]="'priority-' + rec.priority.toLowerCase()">
              {{ rec.priority }}
            </span>
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p class="recommendation-text">{{ rec.recommendation }}</p>
          <div class="recommendation-impact">
            <mat-icon>trending_up</mat-icon>
            <span>{{ rec.expected_impact }}</span>
          </div>
        </mat-card-content>
      </mat-card>
      }
    </div>
  </div>
  } -->

  <!-- Enhanced Analysis Evidence and Recommendations -->
  <app-evidence-and-recommendations
    [evidenceSources]="evidenceSources"
    [recommendations]="recommendations"
    [evidenceTitle]="'Methodology Data Sources'"
    [recommendationsTitle]="'Methodology Improvement Recommendations'">
  </app-evidence-and-recommendations>

  <!-- No Data Message -->
  @if(!hasMethodologyData() && !hasMethodologyComponents()){
  <div class="no-data-message">
    <mat-icon>science</mat-icon>
    <h3>No Methodology Data Available</h3>
    <p>Please select universities and try again.</p>
  </div>
  }
</div>
